// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mp-query-sampling-cta__eNczcS0E{align-items:center;color:var(--primary-text-color);display:flex;flex-direction:column;height:64px;justify-content:space-between;overflow:hidden;padding:10px 0;transition:opacity .2s ease}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mpQuerySamplingCta": "mp-query-sampling-cta__eNczcS0E"
};

/*** EXPORTS FROM exports-loader ***/
export default ___CSS_LOADER_EXPORT___.toString();
